import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutube, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { socialMediaData } from '../../Data/SocialMediaData';

const SOCIAL_ICON_MAP = {
    instagram: faInstagram,
    youtube: faYoutube,
    'x-twitter': faXTwitter,
};

function NavSocials() {
    return (
        <div>
            <div className="navigation-menu-social">
                <h6>FOLLOW</h6>
                <ul>
                    {socialMediaData.map((socialMedia, index) => (
                        <li key={index}>
                            <a href={socialMedia.href} aria-label={socialMedia.label}>
                                <FontAwesomeIcon icon={SOCIAL_ICON_MAP[socialMedia.icon]} aria-hidden="true" />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default NavSocials;
